<template>
  <div id="app">
    <meta name="viewport" content="width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no">
    <meta name="apple-mobile-web-app-capable" content="yes">
    <router-view />
  </div>
</template>
<style lang="less">

</style>

<script>
  export default {
    data() {
        return {
         
        }
    },
  }
</script>
